import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const RequestsTable = ({
  requests,
  selectedRequests,
  onSelectRequest,
  onSelectAll,
  onSort,
  sortField,
  sortDirection,
  onViewRequest,
  onEditRequest,
  onDownloadRequest,
}) => {
  const navigate = useNavigate();
  const getStatusBadge = (status) => {
    const statusConfig = {
      'در حال بررسی': {
        className: 'bg-warning/10 text-warning border-warning/20',
        icon: 'Clock',
      },
      'تکمیل شده': {
        className: 'bg-success/10 text-success border-success/20',
        icon: 'CheckCircle',
      },
      'نیاز به بازنگری': {
        className: 'bg-destructive/10 text-destructive border-destructive/20',
        icon: 'AlertCircle',
      },
    };

    const config = statusConfig?.[status] || statusConfig?.['در حال بررسی'];

    return (
      <span
        className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${config?.className}`}>
        <Icon name={config?.icon} size={12} className="ml-1" />
        {status}
      </span>
    );
  };

  const handleSort = (field) => {
    onSort(field);
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return 'ArrowUpDown';
    return sortDirection === 'asc' ? 'ArrowUp' : 'ArrowDown';
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50 border-b border-border">
            <tr>
              <th className="w-12 p-4">
                <input
                  type="checkbox"
                  checked={
                    selectedRequests?.length === requests?.length &&
                    requests?.length > 0
                  }
                  onChange={(e) => onSelectAll(e?.target?.checked)}
                  className="rounded border-border focus:ring-2 focus:ring-primary"
                />
              </th>
              <th className="text-right p-4 font-medium text-foreground">
                <button
                  onClick={() => handleSort('caseType')}
                  className="flex items-center space-x-1 space-x-reverse hover:text-primary transition-colors">
                  <span>نوع پرونده</span>
                  <Icon name={getSortIcon('caseType')} size={14} />
                </button>
              </th>
              <th className="text-right p-4 font-medium text-foreground">
                <button
                  onClick={() => handleSort('subject')}
                  className="flex items-center space-x-1 space-x-reverse hover:text-primary transition-colors">
                  <span>موضوع</span>
                  <Icon name={getSortIcon('subject')} size={14} />
                </button>
              </th>
              <th className="text-right p-4 font-medium text-foreground">
                <button
                  onClick={() => handleSort('status')}
                  className="flex items-center space-x-1 space-x-reverse hover:text-primary transition-colors">
                  <span>وضعیت</span>
                  <Icon name={getSortIcon('status')} size={14} />
                </button>
              </th>
              <th className="text-right p-4 font-medium text-foreground">
                <button
                  onClick={() => handleSort('createdAt')}
                  className="flex items-center space-x-1 space-x-reverse hover:text-primary transition-colors">
                  <span>تاریخ ایجاد</span>
                  <Icon name={getSortIcon('createdAt')} size={14} />
                </button>
              </th>
              <th className="text-center p-4 font-medium text-foreground">
                عملیات
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {requests?.map((request) => (
              <tr
                key={request?.id}
                className="hover:bg-muted/30 transition-colors">
                <td className="p-4">
                  <input
                    type="checkbox"
                    checked={selectedRequests?.includes(request?.id)}
                    onChange={(e) =>
                      onSelectRequest(request?.id, e?.target?.checked)
                    }
                    className="rounded border-border focus:ring-2 focus:ring-primary"
                  />
                </td>
                <td className="p-4">
                  <div className="flex items-center space-x-2 space-x-reverse">
                    <Icon
                      name="FileText"
                      size={16}
                      className="text-muted-foreground"
                    />
                    <span className="font-medium text-foreground">
                      {request?.caseType}
                    </span>
                  </div>
                </td>
                <td className="p-4">
                  <div className="max-w-xs">
                    <p className="font-medium text-foreground truncate">
                      {request?.subject}
                    </p>
                    <p className="text-sm text-muted-foreground truncate">
                      {request?.claimant} علیه {request?.respondent}
                    </p>
                  </div>
                </td>
                <td className="p-4">{getStatusBadge(request?.status)}</td>
                <td className="p-4 text-muted-foreground">
                  {request?.createdAt}
                </td>
                <td className="p-4">
                  <div className="flex items-center justify-center space-x-1 space-x-reverse">
                    <Button
                      variant="ghost"
                      size="icon"
                      // onClick={() => onViewRequest(request?.id)}
                      onClick={() => navigate('request-details')}
                      className="h-8 w-8">
                      <Icon name="Eye" size={14} />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      onClick={() => onEditRequest(request?.id)}
                      className="h-8 w-8">
                      <Icon name="Edit" size={14} />
                    </Button>
                    {request?.status === 'تکمیل شده' && (
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => onDownloadRequest(request?.id)}
                        className="h-8 w-8 text-success hover:text-success">
                        <Icon name="Download" size={14} />
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RequestsTable;
